import { currencyMap } from "@utils";

export const calculateTimeOnPlatform = (createDate, translate) => {
	let now = Date.now();
	let diff = now - createDate;

	let diffInMinutes = Math.floor(diff / (1000 * 60));
	let diffInHours = Math.floor(diffInMinutes / 60);
	let diffInDays = Math.floor(diffInHours / 24);
	let diffInMonths = Math.floor(diffInDays / 30);
	let diffInYears = Math.floor(diffInDays / 365);

	if (diffInYears > 0) {
		return translate("${value} years on the platform", { value: diffInYears });
	} else if (diffInMonths > 0) {
		return translate("${value} months on the platform", { value: diffInMonths });
	} else if (diffInDays > 0) {
		return translate("${value} days on the platform", { value: diffInDays });
	} else if (diffInHours > 0) {
		return translate("${value} hours on the platform", { value: diffInHours });
	} else {
		return translate("${value} minutes on the platform", { value: diffInMinutes });
	}
};

export const parseId = (id, count) => {
	let strNumber = id?.substring(0, count);
	let result = strNumber + "...";
	return result;
};

export const VALIDATION_RULES = {
	CPF: {
		regex: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/,
		message: "CPF_FORMAT_INVALID",
	},
	CNPJ: {
		regex: /^(\d{2}\.\d{3}\.\d{3}\/0001-\d{2}|\d{14})$/,
		message: "CNPJ_FORMAT_INVALID",
	},
	PHONE: {
		regex: /^(\+55\d{10,11}|\d{10,11})$/,
		message: "PHONE_FORMAT_INVALID",
	},
	EMAIL: {
		regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
		message: "EMAIL_FORMAT_INVALID",
	},
	EVP: {
		regex: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
		message: "EVP_FORMAT_INVALID",
	},
};

export const formatMoney = (value, currency = "TRY") => {
	if (value === null || value === undefined) return "";
	const num = Number(value);
	if (isNaN(num)) return String(value);

	const locale = currencyMap[currency] || "tr-TR";

	const formatter = new Intl.NumberFormat(locale, {
		style: "currency",
		currency: currency,
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	});

	let formatted = formatter.format(num);

	if (currency === "MXN") {
		formatted = formatted.replace("$", "MX$");
	}

	if (currency === "VES") {
		formatted = formatted.replace("Bs.S", "Bs.");
	}

	return formatted;
};
